module.exports = __webpack_public_path__ + "img/live-drop-6922845da41c09630cebf767914ebf68.02d416fa.png";